import { TimeService_timeServiceGetGetTime } from '@festina/life-general-types/life-test/hooks/TimeService_timeServiceGetGetTime'

export const useFetchLifeTimeNoSuspense =
  TimeService_timeServiceGetGetTime.useQuery
